export default __webpack_public_path__ + "static/media/bm-3.614142d9.png";